"use client";

import YourBarrioLogo from "@/components/brand/YourBarrioLogo";

export default function AppErrorFallback({ reset, error = null }) {
  const showDetails = process.env.NODE_ENV !== "production" && error;
  const errorMessage = error?.message || "No error message was provided.";

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f6f7fb] px-4 py-12 text-[#0f0f10] sm:px-6">
      <div className="w-full max-w-[440px] rounded-3xl border border-slate-200/80 bg-white px-6 py-8 text-center shadow-[0_24px_70px_-42px_rgba(15,23,42,0.45)] sm:px-8 sm:py-10">
        <div className="mb-7 flex justify-center">
          <YourBarrioLogo
            variant="navbar-light"
            alt="YourBarrio"
            sizes="148px"
            priority
            className="h-10 w-auto"
          />
        </div>

        <div className="mx-auto mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-[rgba(var(--brand-rgb),0.1)] text-[rgb(var(--brand-rgb))]">
          <span className="text-xl font-semibold" aria-hidden="true">
            !
          </span>
        </div>

        <h1 className="text-2xl font-semibold tracking-tight text-[#0f0f10]">
          Something went wrong
        </h1>
        <p className="mx-auto mt-3 max-w-[20rem] text-sm leading-6 text-slate-600">
          We couldn&rsquo;t load this page. Please try again, or return home.
        </p>

        <div className="mt-8 grid gap-3 sm:grid-cols-2">
          <button
            type="button"
            onClick={() => reset?.()}
            className="inline-flex h-12 w-full items-center justify-center rounded-xl bg-[var(--color-primary)] px-5 text-sm font-semibold !text-white shadow-[0_10px_24px_-14px_rgba(var(--brand-rgb),0.65)] transition hover:bg-[#5E2DE0] hover:!text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-300/30"
          >
            Try again
          </button>
          <button
            type="button"
            onClick={() => {
              window.location.href = "/";
            }}
            className="inline-flex h-12 w-full items-center justify-center rounded-xl border border-slate-200 bg-white px-5 text-sm font-semibold text-[#172033] transition hover:border-slate-300 hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-300/25"
          >
            Go home
          </button>
        </div>

        {showDetails ? (
          <details className="mt-6 rounded-2xl border border-slate-200 bg-slate-50 p-4 text-left">
            <summary className="cursor-pointer text-sm font-semibold text-slate-700">
              Error details
            </summary>
            <p className="mt-3 break-words text-xs leading-5 text-slate-500">
              {errorMessage}
            </p>
          </details>
        ) : null}
      </div>
    </div>
  );
}
